import React, { Component } from 'react'

export default class Testimonial extends Component {
    render() {
        return (            
            <div className="testimonial" style={{width: '100%', padding: '36px'}}>
            <p style={{fontFamily: 'icomoon', fontSize: '50px', color: '#72ad33', margin: 0}}>&#xf10d;</p>
                <p style={{fontSize: '20px'}}>{this.props.text}</p>
                <p style={{color: '#72ad33', fontSize: '18px', paddingLeft: '15px', paddingRight: '15px'}}>{this.props.from}</p>
            </div>
        )
    }
}
